export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://readdy.ai/api/search-image?query=blurred%20out%20of%20focus%20party%20crowd%20photo%20with%20people%20celebrating%20dancing%20and%20having%20fun%20at%20night%2C%20bokeh%20effect%20with%20warm%20ambient%20lighting%20and%20colorful%20party%20lights%20in%20background%2C%20authentic%20real%20photography%20style%20with%20natural%20grain%20texture%20and%20atmospheric%20depth%2C%20dark%20moody%20tones%20with%20glowing%20highlights%20creating%20intimate%20energetic%20nightlife%20atmosphere&width=1920&height=1080&seq=hero-bg-kuze-002&orientation=landscape" 
          alt="Party atmosphere" 
          className="w-full h-full object-cover object-top"
          style={{ filter: 'blur(2px)' }}
        />
        {/* Grain texture overlay */}
        <div className="absolute inset-0 opacity-40" style={{ 
          backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 400 400\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noiseFilter\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noiseFilter)\'/%3E%3C/svg%3E")',
          mixBlendMode: 'overlay'
        }}></div>
        {/* Vignette glow */}
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-black/30 to-black/80" style={{
          background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.8) 100%)'
        }}></div>
        {/* Dark gradient to page background */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-[#0a0a0f]"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full">
        <h1 className="text-5xl md:text-7xl font-bold mb-8 bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400 bg-clip-text text-transparent" style={{ lineHeight: '1.2' }}>
          The party-starter for real-life hangouts.
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
          Kuze is a live multiplayer game that gets everyone involved. Start in seconds. Play together. Have more fun.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
          <a href="https://apps.apple.com/app/kuze/id6742669797" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-[#8B5CF6] to-[#A419E7] rounded-xl text-white hover:opacity-90 transition-all shadow-lg hover:shadow-purple-500/50 whitespace-nowrap cursor-pointer">
            <i className="ri-apple-fill text-2xl"></i>
            <div className="flex flex-col items-start">
              <span className="text-xs font-normal opacity-90">Download on the</span>
              <span className="text-lg font-semibold leading-tight">Apple App Store</span>
            </div>
          </a>
          <a href="https://play.google.com/store/apps/details?id=app.kuze.game" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-[#606FE5] to-[#4758E0] rounded-xl text-white hover:opacity-90 transition-all shadow-lg hover:shadow-blue-500/50 whitespace-nowrap cursor-pointer">
            <i className="ri-google-play-fill text-2xl"></i>
            <div className="flex flex-col items-start">
              <span className="text-xs font-normal opacity-90">Get it on</span>
              <span className="text-lg font-semibold leading-tight">Google Play</span>
            </div>
          </a>
          <a href="https://kuze.app/play" className="flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-[#E348BD] to-[#E11633] rounded-xl text-white hover:opacity-90 transition-all shadow-lg hover:shadow-pink-500/50 whitespace-nowrap cursor-pointer">
            <i className="ri-play-fill text-2xl"></i>
            <div className="flex flex-col items-start">
              <span className="text-xs font-normal opacity-90">No download required</span>
              <span className="text-lg font-semibold leading-tight">Play Online</span>
            </div>
          </a>
        </div>

        <p className="text-base md:text-lg font-semibold text-gray-200 mb-12 tracking-wide">
          Free to start. No subscriptions. No ads.
        </p>
      </div>
    </section>
  );
}
